import { Http } from '@/model/Http.js'
import store from '@/store/index.js'
export default class order extends Http {
  //推广订单
  getOrderList(data){
    const url = 'api/order/search'
    return this.postAjax(url, {
       ...data
    })
  }

 //订单详情
  getOrderInfo(data){
    const url='api/order/get'
    return this.postAjax(url, {
      ...data
    })
  }

  //佣金详情
  getCommissionInfo(data){
    const url='api/order/detail-profit'
    return this.postAjax(url, {
      ...data
    })
  }

  //导出订单
  exportOrder(data){
    const url='api/order/export'
    return this.postAjaxExport(url, {
      ...data
    })
  }

  //拦截订单
  InterceptOrder(data){
    const url='/movie-admin-api/yp-api/admin/shouto-order-intercept/order-intercept'
    return this.postAjax222(url, {
      ...data,
      sourceType:3
    })
  }
  //拦截订单
  cancelOrder(data){
    const url='/movie-admin-api/yp-api/admin/shouto-order-intercept/cancel-order-intercept'
    return this.postAjax222(url, {
      ...data
    })
  }
  //催出票
  urgeBill(data){
    const url='/movie-admin-api/yp-api/ticket/wx-message/ticket-notify'
    return this.postAjax222(url, {
      ...data,
      urgeSource:2,
      nickname:store.getters.nickname
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/order.js